import { useStores } from 'src/components/common/utils/useStore';
import { checkValue } from 'src/components/functions';

export const feedStoreData = () => {
    const { cpcmslitefeed } = useStores();
    return (cpcmslitefeed) ? cpcmslitefeed.conciergePageData : undefined;
}

export const contentModuleData = (content, moduleName) => {
    if (checkValue(content) && content.length > 0 && checkValue(moduleName)) {
        return content?.find(f => f.module === moduleName);
    }
    return null;
}